function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { classNamesFor } from '../utils/classNames';
var cx;
/**
 * The ScrollView component is useful for establishing a scroll view (vertical only) which can
 * adjust it's position based on content as well as providing hooks to indicate
 * whether users have scrolled to the top or bottom for enabled infinite scroll behaviors.
 *
 * ## Usage
 *
 * Note the ScrollView does not set a height or max-height and will expect to be constrained in
 * some way.
 *
 * The most direct way is to set the `height` or `max-height` utilizing a CSS class.
 *
 *   <ScrollView
 *     className="sets-max-height-or-height"
 *     escapeVelocity: 5,
 *     topThreshold: 20,
 *     bottomThreshold: 100,
 *     onScrolledBottom: () => ({}),
 *     onScrolledTop: () => ({}),
 *   >
 *     <div>Some content</div>
 *     <div>Some more content</div>
 *   </ScrollView>
 *
 * The ScrollView can also be embedded in a layout where the height of it's parent is
 * constrained in some way. If only setting the `max-height` be sure to make the container
 * a flexbox utilizing the `psw-l-stack` layout helper. Setting height will not require
 * the flexbox layout.
 *
 * <div className="sets-max-height-or-height psw-l-stack">
 *   <ScrollView
 *     allowPinToBottom: false,
 *     escapeVelocity: 5,
 *     topThreshold: 20,
 *     bottomThreshold: 100,
 *     onInit: (scrollApi) => ({}),
 *     onScrolledBottom: () => ({}),
 *     onScrolledTop: () => ({}),
 *   >
 *     <div>Some content</div>
 *     <div>Some more content</div>
 *   </ScrollView>
 * </div>
 *
 * ## Dependencies
 *
 * The ScrollView component depends on the ResizeObserver API and will need to be polyfilled in
 * [older browsers](https://caniuse.com/resizeobserver).
 */

var ScrollView = /*#__PURE__*/function (_Component) {
  _inherits(ScrollView, _Component);

  var _super = _createSuper(ScrollView);

  function ScrollView(props) {
    var _this;

    _classCallCheck(this, ScrollView);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      isAtBottom: false,
      isAtTop: true,
      isOverflowed: false
    });

    _defineProperty(_assertThisInitialized(_this), "onScrollUp", function (_ref) {
      var velocity = _ref.velocity;
      var escapeVelocity = _this.props.escapeVelocity;

      if (velocity >= escapeVelocity || !_this.isAtBottom()) {
        _this.isScrollPinnedToBottom = false;
      }

      if (_this.wasAtBottom && !_this.isAtTop()) {
        _this.wasAtBottom = false;
      }

      if (!_this.wasAtTop && _this.isAtTop()) {
        var onScrolledTop = _this.props.onScrolledTop;
        _this.wasAtTop = true;
        onScrolledTop({});
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onScrollDown", function () {
      if (_this.wasAtTop && !_this.isAtTop()) {
        _this.wasAtTop = false;
      }

      if (!_this.wasAtBottom && _this.isAtBottom()) {
        var _this$props = _this.props,
            onScrolledBottom = _this$props.onScrolledBottom,
            allowPinToBottom = _this$props.allowPinToBottom;
        _this.wasAtBottom = true;
        _this.isScrollPinnedToBottom = allowPinToBottom;
        onScrolledBottom({});
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onScroll", function (e) {
      var _this$props2 = _this.props,
          onScroll = _this$props2.onScroll,
          onScrolledFromTop = _this$props2.onScrolledFromTop;

      var velocity = _this.getScrollVector();

      var isScrollingUp = velocity > 0;
      onScroll(e);

      if (_this.wasAtTop && !_this.isAtTop()) {
        onScrolledFromTop();
      }

      if (velocity === 0) return;

      if (isScrollingUp) {
        _this.onScrollUp({
          velocity: velocity
        });
      } else {
        _this.onScrollDown();
      }

      _this.lastScrollTop = _this.frame.current.scrollTop;

      _this._computeScrollMeta();
    });

    _defineProperty(_assertThisInitialized(_this), "getScrollVector", function () {
      var currentScrollTop = _this.frame.current.scrollTop;
      return _this.lastScrollTop - currentScrollTop;
    });

    _defineProperty(_assertThisInitialized(_this), "isAtTop", function () {
      if (!_this.frame.current) return true;
      var topThreshold = _this.props.topThreshold;
      return _this.frame.current.scrollTop <= topThreshold;
    });

    _defineProperty(_assertThisInitialized(_this), "isAtBottom", function () {
      var frame = _this.frame.current;
      if (!frame) return false;
      var bottomThreshold = _this.props.bottomThreshold;
      return frame.scrollTop + frame.clientHeight + bottomThreshold >= frame.scrollHeight;
    });

    _defineProperty(_assertThisInitialized(_this), "isOverflowed", function () {
      if (!_this.frame.current) return false;
      return _this.frame.current.scrollHeight <= _this.content.current.scrollHeight;
    });

    _defineProperty(_assertThisInitialized(_this), "scrollToBottom", function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          behavior = _ref2.behavior;

      if (!_this.frame.current) return;
      var allowPinToBottom = _this.props.allowPinToBottom;

      _this.frame.current.scrollTo({
        top: _this.frame.current.scrollHeight,
        behavior: behavior || 'smooth'
      });

      _this.isScrollPinnedToBottom = allowPinToBottom;
    });

    _defineProperty(_assertThisInitialized(_this), "scrollToTop", function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          behavior = _ref3.behavior;

      if (!_this.frame.current) return;

      _this.frame.current.scrollTo({
        top: 0,
        behavior: behavior || 'smooth'
      });
    });

    _defineProperty(_assertThisInitialized(_this), "maintainScrollPosition", function () {
      var diffScrollHeight = _this.frame.current.scrollHeight - _this.lastScrollHeight;
      var newScrollTop = diffScrollHeight + _this.lastScrollTop;
      _this.frame.current.scrollTop = newScrollTop;
    });

    _defineProperty(_assertThisInitialized(_this), "_computeScrollMeta", function () {
      return _this.setState({
        isOverflowed: _this.isOverflowed(),
        isAtBottom: _this.isAtBottom(),
        isAtTop: _this.isAtTop()
      });
    });

    _this.frame = /*#__PURE__*/React.createRef();
    _this.content = /*#__PURE__*/React.createRef();
    _this.lastScrollTop = 0;
    _this.lastScrollHeight = 0;
    _this.isScrollPinnedToBottom = false;
    _this.wasAtTop = true;
    _this.wasAtBottom = false;
    return _this;
  }

  _createClass(ScrollView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          onInit = _this$props3.onInit,
          allowPinToBottom = _this$props3.allowPinToBottom;
      onInit({
        scrollToBottom: this.scrollToBottom,
        scrollToTop: this.scrollToTop,
        isOverflowed: this.isOverflowed
      });
      this.resizeObserver = new ResizeObserver(this._computeScrollMeta);
      this.resizeObserver.observe(this.content.current);

      if (allowPinToBottom) {
        this.scrollToBottom({
          behavior: 'auto'
        });
      } else {
        this._computeScrollMeta();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.isScrollPinnedToBottom) {
        this.maintainScrollPosition();
      }

      return true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.resizeObserver.unobserve(this.content.current);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          Root = _this$props4.as,
          children = _this$props4.children,
          className = _this$props4.className,
          overflowEffect = _this$props4.overflowEffect;
      var _this$state = this.state,
          isOverflowed = _this$state.isOverflowed,
          isAtBottom = _this$state.isAtBottom,
          isAtTop = _this$state.isAtTop;

      var _ScrollView$getClassN = ScrollView.getClassName({
        className: className,
        isOverflowed: isOverflowed,
        isAtTop: isAtTop,
        isAtBottom: isAtBottom,
        overflowEffect: overflowEffect
      }),
          root = _ScrollView$getClassN.root,
          scrollPort = _ScrollView$getClassN.scrollPort,
          content = _ScrollView$getClassN.content,
          bottomEdgeEffect = _ScrollView$getClassN.bottomEdgeEffect,
          topEdgeEffect = _ScrollView$getClassN.topEdgeEffect;

      this.lastScrollHeight = (this.frame.current || {}).scrollHeight || 0;
      return /*#__PURE__*/React.createElement(Root, {
        className: root
      }, overflowEffect !== 'none' && !(!isOverflowed || isAtTop) && /*#__PURE__*/React.createElement("div", {
        className: topEdgeEffect
      }), /*#__PURE__*/React.createElement("div", {
        ref: this.frame,
        onScroll: this.onScroll,
        className: scrollPort
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.content,
        className: content
      }, typeof children === 'function' ? children({
        isAtTop: isAtTop,
        isAtBottom: isAtBottom,
        isOverflowed: isOverflowed,
        scrollToTop: this.scrollToTop,
        scrollToBottom: this.scrollToBottom
      }) : children)), overflowEffect !== 'none' && !(!isOverflowed || isAtBottom) && /*#__PURE__*/React.createElement("div", {
        className: bottomEdgeEffect
      }));
    }
  }]);

  return ScrollView;
}(Component);

_defineProperty(ScrollView, "getClassName", function (_ref4) {
  var className = _ref4.className,
      isAtBottom = _ref4.isAtBottom,
      isAtTop = _ref4.isAtTop,
      isOverflowed = _ref4.isOverflowed,
      overflowEffect = _ref4.overflowEffect;
  return {
    root: cx(className, 'psw-scroll-view', 'psw-clip', 'psw-l-anchor', 'psw-fill-y', 'psw-l-stack', isAtBottom && 'is-at-bottom', isAtTop && 'is-at-top', isOverflowed && 'is-overflowed'),
    scrollPort: cx('psw-scroll-y', 'psw-fill-y', 'psw-l-anchor'),
    content: cx('psw-scroll-view-content'),
    bottomEdgeEffect: cx('psw-pointer-events-off', 'psw-l-anchor-bottom-center', 'psw-l-bottom-center', overflowEffect === 'shadow' ? 'psw-s-overflow-b' : 'psw-s-fade-b', 'psw-fill-x', 'psw-l-z-1', 'psw-p-7'),
    topEdgeEffect: cx('psw-pointer-events-off', 'psw-l-anchor-top-center', 'psw-l-top-center', overflowEffect === 'shadow' ? 'psw-s-overflow-t' : 'psw-s-fade-t', 'psw-fill-x', 'psw-l-z-1', 'psw-p-7')
  };
});

_defineProperty(ScrollView, "useClassNames", function (c) {
  ScrollView.classNames = c;
});

ScrollView.defaultProps = {
  as: 'div',
  className: '',
  allowPinToBottom: false,
  children: null,
  escapeVelocity: 5,
  topThreshold: 20,
  bottomThreshold: 100,
  overflowEffect: 'none',
  onInit: function onInit() {
    return {};
  },
  onScroll: function onScroll() {
    return {};
  },
  onScrolledFromTop: function onScrolledFromTop() {
    return {};
  },
  onScrolledBottom: function onScrolledBottom() {
    return {};
  },
  onScrolledTop: function onScrolledTop() {
    return {};
  }
};
ScrollView.propTypes = {
  /**
   * The elementType to use as the root for the scroll view
   */
  as: PropTypes.elementType,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * When enabled will scroll to the bottom as content is added
   */
  allowPinToBottom: PropTypes.bool,

  /**
   * Content components to fill the scroll view
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node), PropTypes.element, PropTypes.arrayOf(PropTypes.element), PropTypes.func]),

  /**
   * Configurable threshold for how fast the user has to scroll up to
   * disable pin to bottom
   */
  escapeVelocity: PropTypes.number,

  /**
   * The threshold (height) to trigger the `onScrolledTop` callback
   */
  topThreshold: PropTypes.number,

  /**
   * The threshold (height) to trigger the `onScrolledBottom` callback
   */
  bottomThreshold: PropTypes.number,

  /**
   * Visual treatment showing if more content exists outside the top and / or bottom
   * bound of the scroll port.
   */
  overflowEffect: PropTypes.oneOf(['none', 'shadow', 'fade']),

  /**
   * event callback providing the scroll API to outer components
   */
  onInit: PropTypes.func,

  /**
   * event callback to be called when the view is scrolled
   */
  onScroll: PropTypes.func,

  /**
   * event callback to be called when the view is initially scrolled down
   */
  onScrolledFromTop: PropTypes.func,

  /**
   * event callback to be called when user scrolls to the bottom within the set threshold
   */
  onScrolledBottom: PropTypes.func,

  /**
   * event callback to be called when user scrolls to the top within the set threshold
   */
  onScrolledTop: PropTypes.func
};
cx = classNamesFor(ScrollView);
export default ScrollView;